import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

const LANGS = [
  { code: "nl", label: "NL" },
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
  { code: "it", label: "IT" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "nl").split("-")[0];
  return (
    <div
      data-testid="language-switcher"
      className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white p-0.5 shadow-sm"
    >
      <Languages className="ml-2 h-3.5 w-3.5 text-slate-400" />
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          data-testid={`lang-${l.code}`}
          onClick={() => i18n.changeLanguage(l.code)}
          className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${
            current === l.code
              ? "bg-solar-green text-white"
              : "text-slate-500 hover:text-solar-slate"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
